module.exports = __webpack_public_path__ + "img/digital_card_bohinj_header_winter.31c1a5cd.png";